import React, { Component } from "react";
import { Helmet } from "react-helmet";

class About extends Component {
  componentDidMount() {
    document.getElementById("root").classList.remove("welcome");
    document.getElementById("foo").classList.add("overflow");
  }
  render() {
    return (
      <div className="sub-page">
        <Helmet>
          <title>STech - Privacy Policy</title>
          <meta name="description" content="STech - Privacy Policy" />
        </Helmet>
        <header className="clearfix fadeInUp">
          <div className="container">
            <div className="left" />
            <div className="right">
              <h1>Privacy Policy</h1>
              <h2>Version 1.0</h2>
            </div>
          </div>
        </header>
        <section className="clearfix terms fadeInUp">
          <div className="container">
            <div className="content">
              <h2>1. Introduction</h2>
              <p>
                STech Technology UK Limited is a company incorporated in England
                and Wales with company number 10897880 and whose registered
                address is at South Quay Building, 77 Marsh Wall, London,
                England, E14 9SH. (&ldquo;STech&rdquo; &ldquo;Company&rdquo;,
                &ldquo;we&rdquo;,&nbsp;&ldquo;us&rdquo;).
              </p>
              <p>
                &ldquo;Personal Data&rdquo; is data that may identify you or
                could be used to do so alongside other data, and we will collect
                such data in order to provide or market our services to you.
                This may include without limitation your&nbsp;name and address,
                telephone number, and email address and IP address.
              </p>
              <p>
                We adhere to the data protection standards of the European
                Union&rsquo;s General Data Protection Regulations and take data
                protection seriously.
              </p>
              <p>
                In this Privacy Policy, which applies to this website (the
                &ldquo;Website&rdquo;), and to any contact you may have with us
                prior to engaging on a formal basis for services, we explain
                more about&nbsp;the data we collect, how we use it, your rights
                to your personal data and the process for raising complaints.
              </p>
              <h2>2. Data Controller</h2>
              <p>
                In collecting Personal Data from you, STech is a &ldquo;Data
                Controller&rdquo;.
              </p>
              <h2>3. Purpose of Data Collection</h2>
              <p>
                STech collects&nbsp;and processes Personal Data in order to
                provide you with a contract for our services and for the
                legitimate need we have to: provide potential clients (who so
                consent) with marketing and other communications; to assess the
                effectiveness or our website and communications to you; and,
                where applicable, to share Personal Data with third parties who
                have a genuine and lawful need to this data. Without collecting
                your personal data, we would be unable to offer you our services
                or your&nbsp;use of our services would be severely restricted.{" "}
              </p>
              <h2>4. How Your Data is Used</h2>
              <p>STech will use your Personal&nbsp;Data&nbsp;to:&nbsp;</p>
              <p>
                - engage with an enquiry raised by you seeking information about
                our services;
              </p>
              <p>
                - send you information about our products and services where you
                have agreed that we may do so. You may unsubscribe from such
                communications at any time by opting out or by writing to us
              </p>
              <p>
                - to monitor your use of this Website in order to make
                improvements
              </p>
              <p>- to prepare a contract with you for our services</p>
              <p>
                - for compliance and regulatory purposes, or for any other
                purpose as required by an appropriate authority
              </p>
              <p>
                If you do not wish to receive marketing, promotional or sales
                material from STech, you may contact us to opt-out from this
                type of communication or unsubscribe directly.
              </p>
              <p>
                STech may also pass on your Personal&nbsp;Data&nbsp;to trusted
                third parties in order to assist us with the purposes listed
                above. Such disclosures to trusted third parties allow us to
                provide you with the best user experience on our site and shall
                not be used for the purposes of marketing other goods or
                services to you. Although we cannot accept responsibility for
                the actions of third parties, our trusted third parties have
                strict policies regarding the safeguarding and use of personal
                information.&nbsp;
              </p>
              <p>STech shall not transfer Personal Data outside the EEA.</p>
              <p>
                STech shall retain your Personal Data only for as long as
                necessary for the purpose for which it was collected, otherwise
                it shall be deleted in accordance with our policy on the
                retention and destruction of Personal Data.
              </p>
              <p>
                This document has been composed with the instant HTML edior
                tools. Click <a href="https://htmleditor.tools/">here</a> and
                test it for free.
              </p>
              <h2>5. Your Rights</h2>
              <p>
                You retain important rights to the data provided to us. Your
                Personal Data&nbsp;shall&nbsp;be&nbsp;provided&nbsp;to&nbsp;us
                by yourself, and&nbsp;we shall&nbsp;never&nbsp;pass on&nbsp;this
                data&nbsp;to another customer or any other third
                party&nbsp;without your express permission.&nbsp;
              </p>
              <p>You are entitled to:&nbsp;</p>
              <ul>
                <li>
                  Request access to all data held by us about you&nbsp;- we
                  will&nbsp;provide you with a copy of all data we hold about
                  you no later than one month after your request;
                </li>
                <li>
                  Right to require a correction to the data that we hold about
                  you&nbsp;- please contact us so that we can correct any
                  mistake in the data we hold about you as a result of change in
                  your details or error;&nbsp;
                </li>
                <li>
                  Require that we&nbsp;erase
                  any&nbsp;personal&nbsp;data&nbsp;held about you&nbsp;-&nbsp;we
                  will delete all personal data held about you within 30 days;
                </li>
                <li>
                  Withdraw consent for data processing&nbsp;- if you exercise
                  this right against us,&nbsp;we will no longer process your
                  Personal Data, but this will not&nbsp;affect the lawfulness of
                  processing based on consent before you withdrew
                  consent.&nbsp;You&nbsp;may&nbsp;withdraw consent for data
                  processing for marketing purposes only;
                </li>
                <li>
                  Data portability&nbsp;&ndash;&nbsp;on request, we shall send
                  you a copy of any&nbsp;personal data held by&nbsp;us in&nbsp;a
                  machine-readable format so that&nbsp;we or&nbsp;you&nbsp;may
                  easily transfer this data to another data controller.
                </li>
              </ul>
              <p>&nbsp;</p>
              <p>
                STech reserves&nbsp;the right to&nbsp;retain and&nbsp;pass on
                any information to&nbsp;the police and&nbsp;any public,
                regulatory, or other relevant authority as may be required in
                order to carry out any investigation and prosecution
                into&nbsp;any criminal&nbsp;matters or other type of
                incident&nbsp;being investigated&nbsp;by a relevant authority,
                and to deny you your data protection rights where there are
                other overriding objectives.
              </p>
              <p>
                Please contact us on{" "}
                <u>
                  <a href="mailto:info@STech.com">info@STech.com</a>
                </u>{" "}
                if you&nbsp;wish&nbsp;to exercise any of your data protection
                rights or&nbsp;have any questions about your data protection
                rights.
              </p>
              <h2>6. Your Right to Complain</h2>
              <p>
                Please contact us on{" "}
                <u>
                  <a href="mailto:info@STech.com">info@STech.com</a>
                </u>{" "}
                if you have any concerns or complaints pertaining to your
                Personal Data.
              </p>
              <p>
                For further information about your rights to your Personal Data
                including your ability to exercise your right to make a
                complaint, please contact the Information Commissioner&rsquo;s
                Office by telephone on 0303 123 1113 or through their website at{" "}
                <u>
                  <a href="https://ico.org.uk/concerns/">
                    https://ico.org.uk/concerns/
                  </a>
                </u>
              </p>
              <h2>8. Data Security and Encryption</h2>
              <p>
                Your Personal Data&nbsp;is held&nbsp;on servers chosen and
                designed to be secure and resilient. In the unlikely event of a
                breach of your personal data, the incident&nbsp;would be
                handled&nbsp;in accordance with our&nbsp;data breach policy.
              </p>
              <p>
                Please note that email communications with us are not encrypted
                or otherwise secured against outside interference, so
                discretion&nbsp;should be used&nbsp;when providing personal
                details via email.
              </p>
              <h2>9. Changes to the Privacy Policy</h2>
              <p>
                STech reserves the right to amend the Privacy Policy from time
                to time.
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
export default About;
